import { SetTimingKinds } from "../behavior";
import { EditPhaseKinds } from "../../document";

type SetTimingKindsKey = keyof typeof SetTimingKinds;

export class HisInformationProgressMaster {
  static getProgresses(timing: SetTimingKinds): EditPhaseKinds[] {
    const key = SetTimingKinds[timing] as SetTimingKindsKey;
    return HisInformationProgressMaster.dictionary[key];
  }

  private static readonly dictionary: { [x in SetTimingKindsKey]: EditPhaseKinds[] } = {
    EditStart: [
      EditPhaseKinds.EditStart,                    // 記載開始
      EditPhaseKinds.EditStartFirst,               // 記載開始（初回作成時）
    ],
    EditStartFirst: [
      EditPhaseKinds.EditStartFirst,               // 記載開始（初回作成時）
    ],
    None: [],
    NoSavePrint: [
      EditPhaseKinds.Print, // 印刷時
    ],
    OtherEditStart: [
      EditPhaseKinds.Print, // 印刷時
      EditPhaseKinds.Save,  // 書類保存時
      EditPhaseKinds.TemporarySave, // 一時保存時
    ],
    Print: [
      EditPhaseKinds.Print, // 印刷時
    ],
    SaveReport: [
      EditPhaseKinds.Save, // 書類保存時
      EditPhaseKinds.TemporarySave, // 一時保存時
    ],

    WorkflowRequest: [
      EditPhaseKinds.WorkflowRequest, // ワークフロー依頼時
    ],
    WorkflowConfig: [
      EditPhaseKinds.EditStartFirst,              // 初回作成時
      EditPhaseKinds.WorkflowRequest,             // ワークフロー依頼時
      EditPhaseKinds.WorkflowConfig,
    ],
    WorkflowDraftEditStartFirst: [
      EditPhaseKinds.WorkflowDraftCreate,		// 下書きで文書作成
      EditPhaseKinds.WorkflowDraftEditFirst,	// 下書きで文書編集(初回)
    ],
    WorkflowMake1EditStartFirst: [
      EditPhaseKinds.WorkflowMake1Create,		// 作成1で文書作成。下書き進捗が無い場合
      EditPhaseKinds.WorkflowMake1EditFirst,	// 作成1で文書編集(初回)
    ],
    WorkflowMake2EditStartFirst: [
      EditPhaseKinds.WorkflowMake2Create,		// 作成2で文書作成。下書き・作成1進捗ともに無い場合
      EditPhaseKinds.WorkflowMake2EditFirst,	// 作成2で文書編集(初回)
    ],
    WorkflowRecognize: [],
  };
}
